import { Pipe, PipeTransform } from '@angular/core';
import { Perfil } from '../services/models/usuario-admin/perfil.model';

@Pipe({
  name: 'nomePerfil',
  standalone: true,
  pure: true,
})
export class NomePerfilPipe implements PipeTransform {
  transform(listaPerfil: Perfil[], enumPerfilTodos: number): string {
    if (!listaPerfil || listaPerfil.length === 0) {
      return '';
    }

    if (listaPerfil.some(perfil => perfil.idPerfil === enumPerfilTodos)) {
      return listaPerfil.find(perfil => perfil.idPerfil === enumPerfilTodos)?.nome || 'Todos';
    }

    return listaPerfil.map(perfil => perfil.nome).join(', ');
  }
}
